import React from "react";

// Navigate
import { useNavigate, useParams } from "react-router-dom";

// Mui
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import LockIcon from "@mui/icons-material/Lock";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Fade from "@mui/material/Fade";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormLabel from "@mui/material/FormLabel";
import Grid from "@mui/material/Grid2";
import InputAdornment from "@mui/material/InputAdornment";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

// Mui Styles
import { StyledButton, StyledPaper } from "@/styles/mui/globalStyles";
import QrCodeIcon from "@mui/icons-material/QrCode";
import IconButton from "@mui/material/IconButton";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import QRCode from "react-qr-code";

// Components
import { ShopSelection } from "@/components/Filter/shopSelection";
import Layout from "@/components/layout";
import Title from "@/components/title";

// Fetch
import {
  createOrUpdateUser,
  generateQRcode,
  getUserDetail,
} from "@/fetch/fetchStaff";

import { getRoleTypes } from "@/fetch/fetchType";
import { getAllWorkLocation, getRegionOptions } from "@/fetch/fetchWork";
import { useCurrentAction } from "@/hooks/user";
import { useSelector } from "react-redux";

import _ from "lodash";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const StaffManageDetailPage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();
  const userRole = useSelector((state) => state.user.userRole);
  const { id } = useParams();

  // Navigate
  const navigate = useNavigate();
  // States
  const [onChangeData, setOnChangeData] = React.useState({
    full_name: "",
    alias: "",
    staff_code: "",
    customer_code: "",
    work: null,
    password: "",
    role_types_id: 0,
    shop_permission: [],
    apps_permission: { staff_page: false, promoter_page: false },
    shop: [],
    department_id: 1,
    is_delete: false,
  });
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [roleTypes, setRoleTypes] = React.useState([]);
  const [workLocationData, setWorkLocationData] = React.useState([]);
  const [slideTranOn, setSlideTranOn] = React.useState(false);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [qrCodeValue, setQrCodeValue] = React.useState(null);
  const [shopOptions, setShopOptions] = React.useState([]);

  const handleShopFilterChange = (value) => {
    setOnChangeData((prev) => {
      return {
        ...prev,
        shop: value,
      };
    });
  };
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 16,
            marginBottom: 10,
          },
        },
      },
    },
  });
  // Submit
  const onClickSubmit = async (id) => {
    if (
      onChangeData.alias &&
      onChangeData.full_name &&
      onChangeData.customer_code &&
      onChangeData.role_types_id !== 0 &&
      onChangeData.staff_code &&
      onChangeData.work_location_id
    ) {
      await createOrUpdateUser(onChangeData, id).then((data) => {
        if (data && data.results) {
          if (id) {
            setSnackMessage("修改成功");
            setSnackOpen(true);
            setTimeout(() => {
              navigate("/staffManage");
            }, 500);
          } else {
            setSnackMessage("新增成功");
            setSnackOpen(true);
            setTimeout(() => {
              navigate("/staffManage");
            }, 500);
          }
        }
      });
    } else {
      setSnackMessage("請填寫資料");
      setSnackOpen(true);
    }
  };

  const editUser = async () => {
    await getUserDetail(id).then((data) => {
      if (data && data.results) {
        let result = data.data;
        let tempObj = {
          full_name: result.full_name,
          alias: result.alias,
          staff_code: result.staff_code,
          customer_code: result.customer_code,
          department_id: result.department_id,
          password: null,
          mobile: result.mobile,
          email: result.email,
          work_location_id: result.work_location_id,
          work: {
            id: result.work_location_id === null ? 0 : result.work_location_id,
            work_address:
              result.work_address === null ? "未指派" : result.work_address,
            work_name: result.work_name === null ? "未指派" : result.work_name,
            work_location_id:
              result.work_location_id === null ? 0 : result.work_location_id,
            work_telephone:
              result.work_telephone === null ? "" : result.work_telephone,
            work_shortcode:
              result.work_shortcode === null ? "" : result.work_shortcode,
          },
          role_types_id: result.role_types_id,
          is_delete: result.is_delete,
          is_mutilocation: result.is_mutilocation,
          apps_permission: result.apps_permission,
          shop: result.shop_permission,
          shop_permission:
            result.shop_permission === null ? [] : result.shop_permission,
        };

        setOnChangeData({ ...tempObj });
        setSlideTranOn(true);
        setSlideTranOn(true);
      }
    });
  };

  const getWorkLocationDefaultValue = () => {
    const index = _.findIndex(
      workLocationData,
      (workLocation) => workLocation.id === onChangeData.work_location_id
    );
    if (index >= 0) {
      return workLocationData[index];
    }
  };
  const fetchAll = async (id) => {
    const workLocation = await getAllWorkLocation(false);
    const { data: workOptions } = await getRegionOptions();
    setShopOptions(workOptions);
    if (workLocation && workLocation.results) {
      setWorkLocationData(workLocation.data);
    }
    const roleTypes = await getRoleTypes();
    if (roleTypes && roleTypes.results) {
      setRoleTypes(roleTypes.data);
    }

    if (id) {
      await editUser(workLocation);
    } else {
      setTimeout(() => {
        setSlideTranOn(true);
      }, 200);
    }
  };
  React.useEffect(() => {
    fetchAll(id);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      header="StaffManageDetailPage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      selectedIndex={5}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title={`管理員工 / ${id ? "修改員工" : "新增員工"}`}
        history={() => navigate(-1)}
        children={
          <div>
            {id && actions?.loginQRcode && (
              <React.Fragment>
                <IconButton
                  component="label"
                  onClick={async () => {
                    const { token } = await generateQRcode(id);
                    setQrCodeValue(token);
                    setDialogOpen(true);
                    setTimeout(() => {
                      setDialogOpen(false);
                    }, 1000 * 120);
                  }}
                >
                  <QrCodeIcon />
                </IconButton>
              </React.Fragment>
            )}
          </div>
        }
      />
      <Fade in={slideTranOn} mountOnEnter unmountOnExit>
        <StyledPaper page={"yes"}>
          <ThemeProvider theme={theme}>
            <Box Validate sx={{ width: 1, flex: 1 }}>
              <Grid container spacing={2}>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6,
                  }}
                >
                  <TextField
                    disabled={!actions?.update}
                    id="outlined-name"
                    name="full_name"
                    label="員工全名"
                    error={onChangeData.full_name ? false : true}
                    value={onChangeData.full_name}
                    onChange={(event) =>
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      })
                    }
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6,
                  }}
                >
                  <TextField
                    disabled={!actions?.update}
                    id="outlined-name"
                    name="alias"
                    label="別名"
                    error={onChangeData.alias ? false : true}
                    value={onChangeData.alias}
                    onChange={(event) =>
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      })
                    }
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6,
                  }}
                >
                  <TextField
                    disabled={!actions?.update}
                    id="outlined-name"
                    name="mobile"
                    label="電話"
                    value={onChangeData.mobile}
                    onChange={(event) =>
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      })
                    }
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6,
                  }}
                >
                  <TextField
                    disabled={!actions?.update}
                    id="outlined-name"
                    name="email"
                    label="電郵"
                    value={onChangeData.email}
                    onChange={(event) =>
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      })
                    }
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6,
                  }}
                >
                  <TextField
                    disabled={!actions?.update}
                    id="outlined-name"
                    name="staff_code"
                    label="員工號碼"
                    error={onChangeData.staff_code ? false : true}
                    value={onChangeData.staff_code}
                    onChange={(event) =>
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      })
                    }
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6,
                  }}
                >
                  <TextField
                    disabled={!actions?.update}
                    id="outlined-name"
                    name="customer_code"
                    label="員工內部號碼"
                    error={onChangeData.customer_code ? false : true}
                    value={onChangeData.customer_code}
                    onChange={(event) =>
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      })
                    }
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6,
                  }}
                >
                  <Autocomplete
                    disabled={
                      !actions?.update ||
                      (userRole !== "1" && onChangeData.role_types_id === 1)
                    }
                    options={roleTypes}
                    error={onChangeData.role_types_id ? false : true}
                    value={roleTypes.find(
                      (r) => r.id === onChangeData.role_types_id
                    )}
                    groupBy={(option) => option.department_name}
                    getOptionLabel={(option) => option.role_types_name}
                    renderInput={(params) => (
                      <TextField {...params} label="職位" />
                    )}
                    onChange={(event, newValue) => {
                      setOnChangeData({
                        ...onChangeData,
                        role_types_id: newValue.id,
                      });
                    }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6,
                  }}
                >
                  <Autocomplete
                    disabled={!actions?.update}
                    id="work_locations"
                    options={workLocationData}
                    defaultValue={() => getWorkLocationDefaultValue()}
                    disableCloseOnSelect
                    onChange={(event, newValue) => {
                      setOnChangeData({
                        ...onChangeData,
                        work_location_id: newValue.id,
                      });
                    }}
                    getOptionLabel={(option) =>
                      `${option.work_shortcode} - ${option.work_name}`
                    }
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {`${option.work_shortcode} - ${option.work_name}`}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="選擇上班地方"
                        placeholder="上班地方"
                      />
                    )}
                  />
                </Grid>

                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6,
                  }}
                >
                  <TextField
                    disabled={
                      !actions?.update ||
                      !actions?.resetPassword ||
                      (userRole !== "1" && onChangeData.role_types_id === 1)
                    }
                    sx={{ width: "100%" }}
                    id="outlined-password"
                    name="password"
                    label={id ? "重設密碼" : "設定密碼"}
                    // error={onChangeData.password ? false : true}
                    value={onChangeData.password}
                    onChange={(event, newValue) => {
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      });
                    }}
                    type={"text"}
                  />
                </Grid>
                {id && (
                  <>
                    <Grid
                      size={{
                        xs: 12,
                        md: 6,
                        lg: 6,
                      }}
                    >
                      <TextField
                        disabled={
                          !actions?.update || !actions?.permissionSetting
                        }
                        sx={{ width: "100%" }}
                        id="outlined-password"
                        label="權限"
                        onClick={() => {
                          if (!actions?.permissionSetting) return;
                          navigate(`/staffManage/permission/${id}`);
                        }}
                        placeholder={" 權限"}
                        value={["權限設置"]}
                        InputProps={{
                          readOnly: true,
                          endAdornment: (
                            <InputAdornment position="end">
                              <LockIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                  </>
                )}
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6,
                  }}
                >
                  <ShopSelection
                    filter={onChangeData}
                    handleShopFilterChange={handleShopFilterChange}
                    shopOptions={shopOptions}
                  ></ShopSelection>
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 2,
                    lg: 2,
                  }}
                >
                  <FormControl component="fieldset" variant="standard">
                    <FormLabel component="legend">應用程式櫂限</FormLabel>
                    <FormGroup>
                      <FormControlLabel
                        disabled={!actions?.update}
                        control={<Switch color="success" />}
                        label={"員工貢面"}
                        onChange={(event) => {
                          const apps_permission = {
                            ...onChangeData.apps_permission,
                            staff_page: event.target.checked,
                          };
                          setOnChangeData({
                            ...onChangeData,
                            apps_permission,
                          });
                        }}
                        checked={onChangeData.apps_permission.staff_page}
                      />
                      <FormControlLabel
                        disabled={!actions?.update}
                        control={<Switch color="success" />}
                        label={"推銷員頁面"}
                        onChange={(event) => {
                          const apps_permission = {
                            ...onChangeData.apps_permission,
                            promoter_page: event.target.checked,
                          };
                          setOnChangeData({
                            ...onChangeData,
                            apps_permission,
                          });
                        }}
                        checked={onChangeData.apps_permission.promoter_page}
                      />
                    </FormGroup>
                  </FormControl>
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 2,
                    lg: 2,
                  }}
                >
                  <FormControl component="fieldset" variant="standard">
                    <FormLabel component="legend">狀態</FormLabel>
                    <FormControlLabel
                      disabled={!actions?.update}
                      control={<Switch color="success" />}
                      label={!onChangeData.is_delete ? "在職" : "離職"}
                      onChange={(event) =>
                        setOnChangeData({
                          ...onChangeData,
                          is_delete: !event.target.checked,
                        })
                      }
                      checked={!onChangeData.is_delete}
                    />
                    {onChangeData.role_types_id === 3 && (
                      <FormControlLabel
                        disabled={!actions?.update}
                        control={<Switch color="success" />}
                        label="走場"
                        onChange={(event) =>
                          setOnChangeData({
                            ...onChangeData,
                            is_mutilocation: event.target.checked,
                          })
                        }
                        checked={onChangeData.is_mutilocation}
                      />
                    )}
                  </FormControl>
                </Grid>
                {actions?.update && (
                  <Grid
                    container
                    direction="row"
                    sx={{
                      justifyContent: "flex-end",
                      alignItems: "flex-end",
                    }}
                  >
                    <Grid
                      size={{
                        xs: 12,
                        md: 6,
                        lg: 2,
                      }}
                    >
                      <StyledButton
                        variant="contained"
                        size="small"
                        disabled={!actions?.update}
                        onClick={() => onClickSubmit(id ? id : 0)}
                      >
                        <Typography variant="subtitle1" noWrap component="div">
                          確認
                        </Typography>
                      </StyledButton>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Box>
          </ThemeProvider>
        </StyledPaper>
      </Fade>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogContent>
          <QRCode
            id={"QRCode"}
            size={256}
            value={qrCodeValue}
            viewBox={`0 0 256 256`}
          ></QRCode>
        </DialogContent>
      </Dialog>
    </Layout>
  );
};

export default StaffManageDetailPage;
